module.exports = __webpack_public_path__ + "img/header-memoireRingsBudgetMedium.962a737.webp";